export default __webpack_public_path__ + "static/media/UnderactiveIcon.d7210385.svg";